import { createStyles } from 'antd-style';

import {
  INPUT_BASE_HEIGHT,
  ThemeColors,
  ThemeFont,
  ThemeSpaces,
} from '../../../theme';
import {
  responsiveMdVsLg,
  responsiveSmVsMd,
} from '../../../styles/responsiveMixins';

export const useNewShipmentServiceInformationFormStyles = createStyles(
  ({ token }) => ({
    newShipmentServiceInformationTopCol: {
      ...responsiveMdVsLg({ width: '100%' }, { width: '50%' }),
    },
    newShipmentServiceInformationCard: {
      paddingTop: ThemeSpaces.SPACE_NORM_20,
      paddingBottom: ThemeSpaces.SPACE_NORM,
    },
    dangerousGoodsIcon: {
      fontSize: 18,
      color: token.colorPrimary,
      paddingRight: ThemeSpaces.SPACE_NORM_15,
    },
    newShipmentServiceInformationSectionDivider: {
      marginTop: ThemeSpaces.SPACE_NORM,

      [`@media (min-width: ${token.screenLGMin}px)`]: {
        marginLeft: -ThemeSpaces.SPACE_NORM_20,
        marginRight: -ThemeSpaces.SPACE_NORM_20,
      },
      [`@media (max-width: ${token.screenMDMax}px)`]: {
        marginLeft: -ThemeSpaces.SPACE_NORM,
        marginRight: -ThemeSpaces.SPACE_NORM,
      },
    },
    newShipmentServiceInformationSectionDividerTitle: {
      fontWeight: 'bold',
      marginBottom: ThemeSpaces.SPACE_NORM0_5,
      whiteSpace: 'nowrap',

      ...responsiveMdVsLg(
        {
          height: 20,
          lineHeight: '20px',
          paddingLeft: ThemeSpaces.SPACE_NORM,
          fontFamily: ThemeFont.FONT_CONDENSED,
          fontSize: token.fontSize,
          marginTop: token.marginXS,
          borderWidth: 0,
          boxShadow: 'none',
          textTransform: 'initial',
        },
        {
          height: 30,
          lineHeight: '30px',
          backgroundColor: ThemeColors.COLOR_WHITE6,
          paddingLeft: ThemeSpaces.SPACE_NORM_20,
          fontSize: token.fontSize,
          borderBottom: `1px solid ${token.colorWhite}`,
          boxShadow: `0 1px 0 ${token.colorWhite}`,
          marginTop: 0,
          textTransform: 'uppercase',
        }
      ),
    },
    newShipmentDGStepperRow: {
      marginBottom: -ThemeSpaces.SPACE_NORM,

      '> .ant-col': {
        paddingBottom: ThemeSpaces.SPACE_NORM,
      },

      '> .col-1': {
        display: 'flex',
        ...responsiveSmVsMd({ width: '50%' }, { width: 'auto' }),

        '.ant-form-item': {
          flexGrow: 1,
          paddingRight: ThemeSpaces.SPACE_NORM_20,
        },
      },
      '> .col-2': {
        display: 'flex',
        paddingLeft: ThemeSpaces.SPACE_NORM,
        justifyContent: 'flex-start',
        marginLeft: -1,

        ...responsiveSmVsMd({ width: '50%' }, { width: 'auto' }),

        '.ant-form-item': {
          flexGrow: 1,
        },
      },

      '.label': {
        paddingLeft: ThemeSpaces.SPACE_NORM,
        fontSize: token.fontSizeSM,
        color: ThemeColors.COLOR_GREY_BLUISH,
      },
    },
    newShipmentDGYesNo: {
      '> *, .ant-radio-wrapper': {
        lineHeight: `${INPUT_BASE_HEIGHT / 2}px`,
      },
      '.ant-form-item-control-input-content, .ant-radio-group': {
        lineHeight: 0,
      },
    },
    newShipmentUNDescription: {
      '.label': {
        lineHeight: '17px',
      },
      '.text': {
        fontSize: ThemeFont.FONT_SIZE_LG_MINUS,
        fontWeight: 500,
        lineHeight: '18px',
      },
    },
  })
);
